class SignalAggregator {

	public onAllFired = new Signal<()=>void>();
	private _isFinished:boolean = false;
	private _set = new PandaSet<Signal<any>>();

	public addSignal(s:Signal<any>):void {
		if (this._isFinished) {
			PandaConsole.errorUncritical(new PandaError('SignalAggregator:: Attempt to add signal to already finished signal'));
		}
		this._set.addObject(s);
		let listener = s.addListener(()=>{
			s.removeListener(listener);
			this._set.removeObject(s);
			if (this._set.isEmpty()) {
				this.onAllFired.emit();
			}
		});
	}

	public finished():void {
		if (this._isFinished) {
			PandaConsole.errorUncritical(new PandaError('SignalAggregator:: Attempt to finish already finished signal'));
		}
	}
}